import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/PlansPage.css";

const GST_RATE = 0.18; // 18% GST

const calculatePriceWithGST = (basePrice) => {
  const gstAmount = Math.round(basePrice * GST_RATE * 100) / 100;
  const totalPrice = basePrice + gstAmount;
  return {
    basePrice,
    gstAmount,
    totalPrice,
  };
};

const PLANS = [
  {
    id: "basic_listing",
    name: "Basic Plan",
    basePrice: 100,
    ...calculatePriceWithGST(100),
    features: ["1 property listing", "1 month validity", "Basic visibility"],
  },
];

const PlansPage = () => {
  const navigate = useNavigate();

  const handleSelectPlan = (planId) => {
    // Consolidated payment flow - navigate to subscription page with inline checkout
    navigate("/seller-dashboard/subscription");
  };

  return (
    <div className="plans-page">
      <div className="plans-container">
        <header className="plans-header">
          <h1>Choose Your Plan</h1>
          <p>Select a plan to list your properties and reach potential buyers</p>
        </header>

        <div className="plans-grid">
          {PLANS.map((plan) => (
            <div
              key={plan.id}
              className={`plans-card ${plan.popular ? "popular" : ""}`}
            >
              {plan.popular && <span className="plans-badge">Most Popular</span>}
              <h2>{plan.name}</h2>
              <div className="plans-price-breakdown">
                <div className="plans-price-row">
                  <span className="plans-price-label">Base Price:</span>
                  <span className="plans-price-value">₹{plan.basePrice.toFixed(2)}</span>
                </div>
                <div className="plans-price-row">
                  <span className="plans-price-label">GST (18%):</span>
                  <span className="plans-price-value">₹{plan.gstAmount.toFixed(2)}</span>
                </div>
                <div className="plans-price-row plans-price-total">
                  <span className="plans-price-label">Total Price:</span>
                  <span className="plans-price-value">₹{plan.totalPrice.toFixed(2)}</span>
                </div>
                <span className="plans-period">/month</span>
              </div>
              <ul className="plans-features">
                {plan.features.map((f, i) => (
                  <li key={i}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 6L9 17l-5-5"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {f}
                  </li>
                ))}
              </ul>
              <button
                className="plans-cta"
                onClick={() => handleSelectPlan(plan.id)}
              >
                Get Started
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlansPage;
